import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function file({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M14.691 2.11C14.228 2 13.75 2 13.114 2H9.759c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 00-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 6.29 4 6.954 4 7.758v8.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 001.748 1.748c.485.247 1.002.346 1.564.392C8.29 22 8.954 22 9.758 22h4.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 001.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.885c0-.635 0-1.114-.11-1.577a4 4 0 00-.48-1.156c-.248-.406-.587-.745-1.037-1.194l-1.332-1.332c-.449-.45-.788-.789-1.194-1.037a4 4 0 00-1.156-.48zM13 4H9.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 00-.874.874c-.08.156-.145.38-.18.82C6 6.361 6 6.942 6 7.8v8.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 00.874.874c.156.08.38.145.819.18C8.361 20 8.943 20 9.8 20h4.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 00.874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V9h-2a3 3 0 01-3-3V4zm4.56 3c-.12-.142-.312-.338-.673-.699l-1.188-1.188A13.61 13.61 0 0015 4.44V6a1 1 0 001 1h1.56z"
        clipRule="evenodd"
      />
      <path
        stroke="none"
        d="M9 12a1 1 0 100 2h6a1 1 0 100-2H9zM9 16a1 1 0 100 2h3a1 1 0 100-2H9z"
      />
    </svg>
  );
}

export default file;
